import dayjs from 'dayjs';
import { addBusinessDays, formatYYYYMMDDWithDashes } from 'utils/dates';

export const calculateDueDate = (rush: boolean) => {
  const date = addBusinessDays(rush ? 3 : 7, dayjs());
  return formatYYYYMMDDWithDashes(date);
};
